<template>
<div v-if="showType == 'form-builder'" class="separator">
    Page Break
</div>
</template>

<script>
export default {
  name: "PageBreakV1",
  props: ["showType", "id", "form", "formId"],
  methods: {
    getBakedLayout() {
      return "";
    }
  }
};
</script>

<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px dashed #000;
}

.separator:not(:empty)::before {
  margin-right: .25em;
}

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>
